import { memo, useEffect } from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ".././inner.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

function FractureTraumaCare() {
  useEffect(() => {
    document.title = "Fracture & Trauma Care | Viksha Health Care";
    const newMetaDescription =
      "Fracture and trauma care at Viksha Health Care. Prompt assessment, stabilization, imaging, and a clear plan for healing and follow-up.";
    const metaTag = document.querySelector('meta[name="description"]');
    if (metaTag) {
      metaTag.setAttribute("content", newMetaDescription);
    }
  }, []);

  return (
    <>
      <h2 style={{ fontSize: "0px" }}>Fracture & Trauma Care</h2>
      <div className="serinfobox">
        <div className="serinfoimg">
          <LazyLoadImage src="/photo/Fracture-Trauma-Care.avif" />
        </div>
        <div className="textareaofser">
          <h1>Fracture & Trauma Care</h1>

          <p>
            Fractures and traumatic injuries require timely evaluation and
            proper care to ensure safe healing and restoration of normal
            movement. Fracture and trauma care focuses on diagnosing bone
            injuries, stabilizing the affected area, relieving pain, and guiding
            recovery.
          </p>

          <p>
            Injuries can occur due to falls, road traffic accidents, sports
            activities, or direct impact. Early treatment reduces complications,
            prevents deformity, and supports faster return to daily activities.
          </p>

          <h5>Common Traumatic Injuries Treated</h5>
          <ul>
            <li>Simple and complex bone fractures</li>
            <li>Joint dislocations</li>
            <li>Soft tissue injuries associated with fractures</li>
            <li>Sports-related trauma</li>
            <li>Injuries from accidents or falls</li>
            <li>Multiple injuries affecting bones and joints</li>
          </ul>

          <h5>Types of Fractures</h5>
          <ul>
            <li>Closed fractures where the skin remains intact</li>
            <li>Open fractures where the bone is exposed through the skin</li>
            <li>Hairline or stress fractures</li>
            <li>Displaced fractures where bone alignment is altered</li>
          </ul>

          <h5>Evaluation and Diagnosis</h5>
          <p>
            A detailed examination helps assess the injured area, followed by
            imaging tests when needed to confirm the fracture type and severity.
            Proper assessment ensures that treatment is planned accurately and
            safely.
          </p>

          <h5>Emergency Stabilization</h5>
          <p>
            Immediate care focuses on stabilizing the injured limb, controlling
            pain, and preventing further damage. In serious injuries, emergency
            measures are taken to protect surrounding nerves, blood vessels, and
            soft tissues.
          </p>

          <h5>Treatment Options</h5>

          <h6>Non-Surgical Management</h6>
          <p>
            Many fractures can be treated with casts, splints, or braces to
            stabilize the bone while it heals. Pain management and activity
            restriction are also important during recovery.
          </p>

          <h6>Surgical Treatment</h6>
          <p>
            In more complex fractures or unstable injuries, surgical procedures
            may be required to realign and stabilize the bones using specialized
            techniques. Surgery helps ensure proper healing, maintain bone
            alignment, and restore function.
          </p>

          <h5>Rehabilitation After Injury</h5>
          <p>
            After the fracture begins to heal, rehabilitation exercises help
            restore strength, flexibility, and joint movement. Gradual return to
            activity helps prevent stiffness, muscle weakness, and long-term
            mobility problems.
          </p>

          <h5>Healing Time and Recovery</h5>
          <p>
            Healing time varies depending on the type of fracture, age, overall
            health, and treatment method. Regular follow-up visits are important
            to monitor progress and adjust care when needed.
          </p>

          <h5>Possible Complications If Untreated</h5>
          <ul>
            <li>Improper bone healing</li>
            <li>Persistent pain or stiffness</li>
            <li>Reduced joint movement</li>
            <li>Long-term functional limitations</li>
          </ul>

          <h5>When to Seek Immediate Care</h5>
          <ul>
            <li>Severe pain after injury</li>
            <li>Visible deformity or swelling</li>
            <li>Inability to move or bear weight</li>
            <li>Open wounds near the injury site</li>
            <li>Numbness or loss of sensation</li>
          </ul>

          <p>
            Proper fracture and trauma care ensures safe healing, reduces the
            risk of complications, and helps patients return to normal life as
            quickly and comfortably as possible.
          </p>
        </div>
      </div>
    </>
  );
}

export default memo(FractureTraumaCare);
